import React, { useState, useEffect } from 'react';
import CaseStudyLevel1 from './CaseStudyLevel1';
import CaseStudyLevel2 from './CaseStudyLevel2';
import CaseStudyLevel3 from './CaseStudyLevel3';
import './CaseStudy.css';

const SCENARIOS = [
  { id: 'congestion-pricing', label: 'Congestion Pricing', file: '/data/case-study/congestion-pricing.json' },
  { id: 'school-zones', label: 'School Zones Speed Limit', file: '/data/case-study/school-zones.json' },
];

const LEVELS = ['Network Summary', 'Spatial/Zone Analysis', 'Bottleneck Analysis'];

function CaseStudy() {
  const [activeScenario, setActiveScenario] = useState(SCENARIOS[0].id);
  const [activeLevel, setActiveLevel] = useState('Network Summary');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const scenario = SCENARIOS.find(s => s.id === activeScenario);
    setLoading(true);
    setError(null);
    fetch(scenario.file)
      .then(res => {
        if (!res.ok) throw new Error(`Failed to load data: ${res.status}`);
        return res.json();
      })
      .then(json => { setData(json); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, [activeScenario]);

  const scenarioLabel = activeScenario === 'congestion-pricing' ? 'Congestion Pricing' : 'School Zones';

  const renderLevel = () => {
    if (!data) return null;
    switch (activeLevel) {
      case 'Network Summary': return <CaseStudyLevel1 data={data.level1} scenarioLabel={scenarioLabel} />;
      case 'Spatial/Zone Analysis': return <CaseStudyLevel2 data={data.level2} scenarioLabel={scenarioLabel} />;
      case 'Bottleneck Analysis': return <CaseStudyLevel3 data={data.level3} />;
      default: return null;
    }
  };

  return (
    <div className="case-study-container">
      <h1 className="case-study-title">Case Study: Manhattan</h1>

      <div className="case-study-scenario-tabs">
        {SCENARIOS.map(s => (
          <button
            key={s.id}
            className={activeScenario === s.id ? 'tab-active' : ''}
            onClick={() => setActiveScenario(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="case-study-body">
        <div className="case-study-level-tabs">
          {LEVELS.map(level => (
            <button
              key={level}
              className={activeLevel === level ? 'tab-active' : ''}
              onClick={() => setActiveLevel(level)}
            >
              {level}
            </button>
          ))}
        </div>

        <div className="case-study-content">
          {loading && <div className="case-study-loading">Loading data...</div>}
          {error && <div className="case-study-error">{error}</div>}
          {!loading && !error && renderLevel()}
        </div>
      </div>
    </div>
  );
}

export default CaseStudy;
